exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.kye-preview-file-dialog .el-loading-spinner .circular {\n  width: 22px;\n  height: 22px;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-preview/component/preview-wrapper/preview-file.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd","file":"preview-file.vue","sourcesContent":["\n.kye-preview-file-dialog .el-loading-spinner .circular {\n  width: 22px;\n  height: 22px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19c87e50","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/kye-preview/component/preview-wrapper/preview-file.vue
// module id = g2Hm
// module chunks = 7